
<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="editable || showable"
        />
      </a-form-item>
      <a-form :form="form">
        <a-form-item
          label="主键"
          :labelCol="labelCol"
          :hidden="true"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="名称"
          :labelCol="labelCol"
          :hidden="distractable"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['name', {rules: [{required: true, message: '请输入名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="规格"
          :labelCol="labelCol"
          :hidden="distractable"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['format', {rules: [{required: true, message: '请输入规格'}]}]" />
        </a-form-item>
        <a-form-item
          label="数量"
          :labelCol="labelCol"
          :hidden="distractable"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :disabled="showable"
            :min="0"
            :step="1"
            v-decorator="['number', {rules: [{required: true, message: '请输入数量'}]}]" />
        </a-form-item>
        <a-form-item
          label="状态"
          :labelCol="labelCol"
          :hidden="distractable"
          :wrapperCol="wrapperCol"
        >
          <a-select
            :disabled="showable"
            v-decorator="['state', {rules: [{required: true, message: '请输入状态'}]}]">
            <a-select-option value="0">损坏</a-select-option>
            <a-select-option value="1">正常</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="所在项目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择所在项目"
            showSearch
            :filterOption="filterOption"
            :disabled="showable"
            :options="projectList"
            v-decorator="['projectId', {rules: [{required: false, message: '请选择所在项目'}]}]" >
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable || distractable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { getObj, addObj, putObj, damObj } from '@/api/common/SxAsset'
import { dropProjectList } from '@/api/common/SxCompanyMachine'

export default {
  name: 'SxAssetAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false,
      projectList: []
    }
  },
  methods: {
    edit (id, type) {
      dropProjectList().then(res => {
        this.projectList = res.data
      })
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show', 'dem', 'distract'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'name', 'format', 'number', 'unit', 'orderNumber', 'state', 'supplierId', 'remark', 'purchaserId', 'unitPrice', 'totalPrice', 'projectId']))
          })
        })
      } else {
        resetFields()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            } else if (this.type === 'dem') {
              await damObj(values)
            } else if (this.type === 'distract') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
